/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

export const LeftVariant = {
  Default: "default",
  Critical: "critical",
  Warning: "warning",
  Caution: "caution",
} as const;
export type LeftVariant = OpenEnum<typeof LeftVariant>;

export const RightVariant = {
  Default: "default",
  Critical: "critical",
  Warning: "warning",
  Caution: "caution",
} as const;
export type RightVariant = OpenEnum<typeof RightVariant>;

/**
 * Independent compartment levels and fill colors. Labels are carried by animatic labels.
 */
export type AnimaticDualHopperConfig = {
  /**
   * A reference to a reading or setting.
   */
  leftLevel?: Ref | undefined;
  leftVariant?: LeftVariant | undefined;
  /**
   * A reference to a reading or setting.
   */
  rightLevel?: Ref | undefined;
  rightVariant?: RightVariant | undefined;
};

/** @internal */
export const LeftVariant$inboundSchema: z.ZodType<
  LeftVariant,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(LeftVariant);
/** @internal */
export const LeftVariant$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  LeftVariant
> = openEnums.outboundSchema(LeftVariant);

/** @internal */
export const RightVariant$inboundSchema: z.ZodType<
  RightVariant,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(RightVariant);
/** @internal */
export const RightVariant$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  RightVariant
> = openEnums.outboundSchema(RightVariant);

/** @internal */
export const AnimaticDualHopperConfig$inboundSchema: z.ZodType<
  AnimaticDualHopperConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  left_level: types.optional(Ref$inboundSchema),
  left_variant: types.optional(LeftVariant$inboundSchema),
  right_level: types.optional(Ref$inboundSchema),
  right_variant: types.optional(RightVariant$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "left_level": "leftLevel",
    "left_variant": "leftVariant",
    "right_level": "rightLevel",
    "right_variant": "rightVariant",
  });
});
/** @internal */
export type AnimaticDualHopperConfig$Outbound = {
  left_level?: Ref$Outbound | undefined;
  left_variant?: string | undefined;
  right_level?: Ref$Outbound | undefined;
  right_variant?: string | undefined;
};

/** @internal */
export const AnimaticDualHopperConfig$outboundSchema: z.ZodType<
  AnimaticDualHopperConfig$Outbound,
  z.ZodTypeDef,
  AnimaticDualHopperConfig
> = z.object({
  leftLevel: Ref$outboundSchema.optional(),
  leftVariant: LeftVariant$outboundSchema.optional(),
  rightLevel: Ref$outboundSchema.optional(),
  rightVariant: RightVariant$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    leftLevel: "left_level",
    leftVariant: "left_variant",
    rightLevel: "right_level",
    rightVariant: "right_variant",
  });
});

export function animaticDualHopperConfigToJSON(
  animaticDualHopperConfig: AnimaticDualHopperConfig,
): string {
  return JSON.stringify(
    AnimaticDualHopperConfig$outboundSchema.parse(animaticDualHopperConfig),
  );
}
export function animaticDualHopperConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticDualHopperConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticDualHopperConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticDualHopperConfig' from JSON`,
  );
}
